// frontend/src/utils/locale.js
import api from './api';

// Switching the site language switches the language of the emails too — the
// confirmation of a contract has to be in the language it was concluded in. Fire
// and forget: nobody's language toggle should fail because the network did.
export function rememberLocale(locale) {
  if (!localStorage.getItem('glamgo_token')) return;
  api.put('/auth/locale', { locale }).catch(() => {});
}
